module.exports = __webpack_public_path__ + "img/centrallevelcomplaintsstatus.f5e48d7d.svg";